import { FormControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

//https://github.com/ngx-formly/ngx-formly/issues/2059
export function VimboFieldMatchValidator(
    control: FormControl,
    fieldConfig: FormlyFieldConfig
): ValidationErrors {

    if (!control.parent || !control) {
        return null;
    }

    // return null if you have not passed the analyzeFieldMatch setting,
    // it means that this field does not need this validation
    if (!fieldConfig.templateOptions.analyzeFieldMatch) {
        return null;
    }

    // Compare fields
    const field = control.parent.parent.get(fieldConfig.key.toString());
    const fieldConfirm = control.parent.parent.get(fieldConfig.templateOptions.analyzeFieldMatch);

    // Avoid displaying the message error when values are empty
    if (!field || !fieldConfirm) {
        return null;
    }

    // if (fieldConfirm.value === '') {
    //     return null;
    // }

    let fieldVal = field.value;
    let fieldConfVal = fieldConfirm.value;

    if (fieldConfig.templateOptions.analyzeFieldMatchSourceStart) {
        fieldVal = fieldVal.substr(fieldConfig.templateOptions.analyzeFieldMatchSourceStart, fieldConfig.templateOptions.analyzeFieldMatchSourceEnd);
    }

    // regex for own field
    if (fieldConfig.templateOptions.analyzeFieldMatchSourceRegex) {

        //todo find better way 
        let r = fieldConfig.templateOptions.analyzeFieldMatchSourceRegex.replace(/\\\\/g, "\\");

        var myRegexp = new RegExp(r, "g");
        let res = myRegexp.exec(fieldVal as string);

        if (res?.length > 0)
            fieldVal = res[0];
    }

    if (fieldConfVal && fieldConfig.templateOptions.customBinding)
        for (let part of fieldConfig.templateOptions.customBinding.split('.'))
            fieldConfVal = fieldConfVal[part];
    //regex for other field
    if (fieldConfig.templateOptions.analyzeFieldMatchTargetRegex) {

        //todo find better way 
        let r = fieldConfig.templateOptions.analyzeFieldMatchTargetRegex.replace(/\\\\/g, "\\");

        var myRegexp = new RegExp(r, "g");
        let res = myRegexp.exec(fieldConfVal as string);

        if (res?.length > 0)
            fieldConfVal = res[0];
    }

    // Equal
    if (fieldVal == fieldConfVal) {
        return { fieldMatch: true };
    }

    // return validator
    return null;
}